import { Option } from '@/types/options';
import { Button } from '../Button/Button';
import {
  Dialog,
  DialogTitle,
  DialogHeader,
  DialogContent,
  DialogBody,
  DialogFooter,
} from '../Dialog/Dialog';
import { RadioButton, RadioGroup } from '../RadioGroup/RadioGroup';
import { TextButton } from '../TextButton/TextButton';
import { useTranslations } from 'next-intl';

interface SelectDialogProps {
  title: string;
  isOpen: boolean;
  isEnableClear: boolean;
  value: string | undefined;
  options: Option[];
  onOpenChange: (isOpen: boolean) => void;
  onValueChange: (value: string) => void;
  onClickClear: () => void;
}

export function SelectDialog({
  title,
  isOpen = false,
  isEnableClear = false,
  value,
  options,
  onValueChange,
  onClickClear,
  onOpenChange,
}: SelectDialogProps) {
  const t = useTranslations('common');
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <TextButton fontWeight="bold" disabled={!isEnableClear} onClick={onClickClear}>
            {t('selectDialog.clear')}
          </TextButton>
        </DialogHeader>
        <DialogBody>
          <RadioGroup onValueChange={onValueChange} value={value}>
            <div className="grid grid-cols-1 gap-2 pc:grid-cols-2">
              {options.map((option) => (
                <div key={option.value} className="border-b-thin border-neutral-auxiliary py-3">
                  <RadioButton
                    key={option.value}
                    id={option.value}
                    value={option.value}
                    label={option.label}
                  />
                </div>
              ))}
            </div>
          </RadioGroup>
        </DialogBody>
        <DialogFooter>
          <Button colorScheme="secondary" onClick={() => onOpenChange(false)}>
            {t('action.cancel')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
